// src/hooks/usePageContent.js
import { useState } from 'react';
import { getValue } from '../services/pageContentService';

const usePageContent = () => {
    const [status, setStatus] = useState('idle'); // idle | loading | done | error
    const [error, setError] = useState('');
    const [data, setData] = useState([]);

    const fetchPageContent = async ({ type, field, language }) => {
        setStatus('loading');
        setError('');

        try {
            const response = await getValue({ type, field, language });

            if (response?.status !== 'Error') {
                setData(response.data ?? response); // depending on API shape
                setStatus('done');
            } else {
                setStatus('error');
                setError(response?.message || 'Something went wrong');
            }
        } catch (err) {
            setStatus('error');
            setError(err?.message || 'Something went wrong');
        }
    };

    

    const resetStatus = () => {
        setStatus('idle');
        setError('');
    };

    return {
        fetchPageContent,
        data,
        status,
        error,
        resetStatus
    };
};

export default usePageContent;
